const MAX_TIME_STRING = '23:59:59:999';

export default MAX_TIME_STRING;
